export default __webpack_public_path__ + "static/media/closet2-768w.928151c0.avif";